import React from "react";
import { useField } from "formik";

export default function ToggleSwitch({ toggleTarget, callbackToggle }) {
  return (
    <div
      onClick={() => callbackToggle(!toggleTarget)}
      style={{
        width: "2.5rem",
        minWidth: "2.5rem",
        height: "auto",
        borderRadius: "1rem",
        transition: "all 0.1s ease-in-out",
      }}
      className={
        "d-flex align-items-center p-1 " +
        (toggleTarget
          ? "justify-content-end bg-primary"
          : "justify-content-start bg-secondary")
      }
    >
      <div
        className="rounded-circle bg-white shadow"
        style={{
          width: "1.2rem",
          height: "1.2rem",
          transition: "all 0.2s ease-in-out",
        }}
      ></div>
    </div>
  );
}

export function FormToggleSwitch({ name, onChange = null }) {
  const [field, meta, helpers] = useField(name);
  const { value } = field;
  const { setValue } = helpers;
  return (
    <>
      <ToggleSwitch
        toggleTarget={value}
        callbackToggle={onChange ?? setValue}
      />
      {meta.touched && meta.error && (
        <span className="text-danger">{meta.error}</span>
      )}
    </>
  );
}
